import createLog from './create-log.endpoint.api';

const client = {
    api: {
        createLog,
    },
};

export default client;
